import { reactive, ref, toRaw } from 'vue'
import { createStore } from 'vuex'
import user from './_user'
import page from './_page'
import news from './_news'
import case2 from './_case'
import faq from './_faq'
import product from './_product'
import cert from './_cert'
import module from './_module'
import download from './_download.js'
import common from './_common.js'
import { getClosestBusinessNode } from '@/components/common/controlBar/controlBarDialog/metaComponent/utils.js'
import { TEXT_REMARK_OBJECT } from '@/consts/base.js'
import {isEnableCatching} from "@/components/common/controlBar/controlBarDialog/event/index.js";

let deviceMode = 'diannao'

if (location.href.indexOf('/pingban') > -1) {
  deviceMode = 'pingban'
} else if (location.href.indexOf('/shouji') > -1) {
  deviceMode = 'shouji'
}

function getHistoryId(step) {
  return step[0].historyId
}

function addIds(list, id) {
  for (let i = 0; i < list.length; i++) {
    list[i].id = id ? `${id}_${i}` : `id_${i}`
    if (list[i].list) {
      addIds(list[i].list, list[i].id)
    }
  }
}

function getIndexOfStep(current, history) {
  var res
  history.forEach((item, index) => {
    if (getHistoryId(item) === getHistoryId(current)) {
      res = index
    }
  })
  return res
}

export function isFirstStep(current, history) {
  return getIndexOfStep(current, history) === 0
}

export function isLastStep(current, history) {
  var res = getIndexOfStep(current, history) === history.length - 1
  return res
}

function deleteStep(step, state) {
  var index = getIndexOfStep(step, state.history)
  state.history.splice(index, 1)
}

function removeControllerData(index) {
  if (index > -1) {
    // 在移除前清理可能的循环引用或大对象
    if (state.dialogNodes[index].controllerModule) {
      // 断开可能的大对象引用
      state.dialogNodes[index].controllerModule = null
    }
    if (state.dialogNodes[index].data) {
      state.dialogNodes[index].data = null
    }
    state.dialogNodes.splice(index, 1)
  }
}

function measureObjectSize(obj) {
  if (typeof obj !== 'object' || obj === null) {
    return 0
  }

  const seen = new WeakSet()

  function getSize(obj) {
    if (obj === null || typeof obj !== 'object' || seen.has(obj)) {
      return 0
    }

    seen.add(obj)

    let size = 0
    if (Array.isArray(obj)) {
      size = obj.length * 4 // 数组基础开销
      for (const item of obj) {
        size += getSize(item)
      }
    } else {
      for (const key in obj) {
        size += key.length * 2 // 键名大小
        size += getSize(obj[key]) // 值大小
      }
    }

    return size
  }

  return getSize(obj)
}

export function clearRemainingHistoryQuquesFromCurrent(state) {
  var index = getIndexOfStep(state.hasList, state.history)
  if (index) {
    // state.history.forEach((item, itemIndex)=>{
    //   if(itemIndex > index){
    //     item.isNeedDelete = true
    //     deleteStep(item, state)
    //   }else{
    //     item.isNeedDelete = false
    //   }
    // })

    state.history = state.history.filter((item, itemIndex) => {
      if (itemIndex <= index) {
        return true
      }
    })
  }
}
export function updateHistory(type, state) {
  if (state.history.length > 0) {
    var index = getIndexOfStep(state.hasList, state.history)

    let targetIndex
    if (type === 'backward') {
      targetIndex = index - 1
    } else if (type === 'forward') {
      targetIndex = index + 1
    } else {
      targetIndex = index
    }

    const hasList = mm.utils.deepCopy(state.history[targetIndex])

    // const hasList = mm.utils.deepCopy(
    //   state.history[
    //     (() => {
    //       if (type === 'backward') {
    //         return index - 1
    //       } else if (type === 'forward') {
    //         return index + 1
    //       }
    //     })()
    //   ]
    // )
    state.hasList = hasList
    state.bodyKey++

    mm.store.commit('UPDATE_HAS_LIST', hasList)
    mm.store.commit('UPDATE_RECT')
    mm.store.commit('EMPTY_DIALOG')
  }
}
// 所有权限列表
// 1. 通过 <mm-auth auth="translate"></mm-auth>
// 2. 通过 v-auth="'translate'" 注意是字符串
const allAuthList = [
  // 顶部
  {
    key: 'translate',
    name: '翻译'
  },
  {
    key: 'page',
    name: '切换页面'
  },
  {
    key: 'media',
    name: '切换三端'
  },
  {
    key: 'ruler',
    name: '辅助线'
  },
  {
    key: 'background',
    name: '全局背景'
  },
  {
    key: 'font',
    name: '全局字体'
  },
  {
    key: 'theme',
    name: '全局设置'
  },
  {
    key: 'safeRange',
    name: '安全范围'
  },
  {
    key: 'display',
    name: '显示/隐藏'
  },
  {
    key: 'source',
    name: '数据源'
  },
  {
    key: 'preview',
    name: '预览'
  },
  {
    key: 'prev',
    name: '撤销'
  },
  {
    key: 'next',
    name: '恢复'
  },
  {
    key: 'cancel',
    name: '取消'
  },
  {
    key: 'save',
    name: '保存'
  },
  {
    key: 'publish',
    name: '发布'
  },
  {
    key: 'goBack',
    name: '返回后台'
  },
  // 侧边
  {
    key: 'module',
    name: '模块库'
  },
  {
    key: 'widgets',
    name: '控件库'
  },
  {
    key: 'template',
    name: '模板库'
  },
  {
    key: 'collect',
    name: '收藏'
  },
  {
    key: 'common',
    name: '公共板块'
  },
  {
    key: 'aiWebsiteBuilder',
    name: 'AI建站'
  }
]

export default createStore({
  modules: {
    user,
    page,
    news,
    case2,
    faq,
    product,
    cert,
    module,
    download,
    common
  },
  state: {
    commonDialog: {
      node: null,
      isVisible: false
    },
    catchNode: null,
    isForceEnableArabicContext2: false,
    isViewOfHiddenNode: true,
    authList: allAuthList,
    translateDialog: {
      startNode: undefined,
      isShow: false
    },
    tools: {},
    topMenu: {
      ruler: {
        isShow: true,
        topList: new Array(19).fill(0).map((item, index) => (!index ? 0 : `${index}00`)),
        leftList: new Array(10).fill(0).map((item, index) => (!index ? 0 : `${index}00`))
      }
    },
    rightMenu: {
      isShow: false,
      isShowDel: true
    },
    authInfo: {
      ksh_global_theme_color: {
        color: {
          dominantColor: 'rgb(0, 92, 179)',
          secondaryColor: 'rgba(0, 92, 179, 0.6)',
          titleColor: 'rgb(51, 51, 51)',
          paragraphColor: 'rgb(102, 102, 102)',
          btnBorderColor: 'rgb(136, 136, 136)',
          writeColor: 'rgb(255, 255, 255)',
          presetColor1: '',
          presetColor2: '',
          presetColor3: '',
          presetColor4: '',
          presetColor5: '',
          presetColor6: ''
        },
        text: [
          {
            id: 1,
            name: 'title1',
            title: '标题1',
            fontFamilyType: 1,
            fontFamilyId: 68,
            fontFamily: 'var(--globalFont)',
            remark: '',
            diannao: {
              fontSize: 40,
              fontSizeUnit: 'px',
              letterSpacing: 0,
              letterSpacingUnit: 'px'
            },
            pingban: {
              fontSize: 32,
              fontSizeUnit: 'px',
              letterSpacing: 0,
              letterSpacingUnit: 'px'
            },
            shouji: {
              fontSize: 20,
              fontSizeUnit: 'px',
              letterSpacing: 0,
              letterSpacingUnit: 'px'
            }
          },
          {
            id: 2,
            name: 'subtitle',
            title: '副标题',
            fontFamilyType: 1,
            fontFamilyId: 68,
            fontFamily: 'var(--globalFont)',
            remark: '',
            diannao: {
              fontSize: 16,
              fontSizeUnit: 'px',
              letterSpacing: 0,
              letterSpacingUnit: 'px'
            },
            pingban: {
              fontSize: 16,
              fontSizeUnit: 'px',
              letterSpacing: 0,
              letterSpacingUnit: 'px'
            },
            shouji: {
              fontSize: 14,
              fontSizeUnit: 'px',
              letterSpacing: 0,
              letterSpacingUnit: 'px'
            }
          },
          {
            id: 3,
            name: 'title2',
            title: '标题2',
            fontFamilyType: 1,
            fontFamilyId: 68,
            fontFamily: 'var(--globalFont)',
            remark: TEXT_REMARK_OBJECT[3],
            diannao: {
              fontSize: 30,
              fontSizeUnit: 'px',
              letterSpacing: 0,
              letterSpacingUnit: 'px'
            },
            pingban: {
              fontSize: 26,
              fontSizeUnit: 'px',
              letterSpacing: 0,
              letterSpacingUnit: 'px'
            },
            shouji: {
              fontSize: 20,
              fontSizeUnit: 'px',
              letterSpacing: 0,
              letterSpacingUnit: 'px'
            }
          },
          {
            id: 4,
            name: 'title3',
            title: '标题3',
            fontFamilyType: 1,
            fontFamilyId: 68,
            fontFamily: 'var(--globalFont)',
            remark: TEXT_REMARK_OBJECT[4],
            diannao: {
              fontSize: 24,
              fontSizeUnit: 'px',
              letterSpacing: 0,
              letterSpacingUnit: 'px'
            },
            pingban: {
              fontSize: 20,
              fontSizeUnit: 'px',
              letterSpacing: 0,
              letterSpacingUnit: 'px'
            },
            shouji: {
              fontSize: 18,
              fontSizeUnit: 'px',
              letterSpacing: 0,
              letterSpacingUnit: 'px'
            }
          },
          {
            id: 5,
            name: 'title4',
            title: '标题4',
            fontFamilyType: 1,
            fontFamilyId: 68,
            fontFamily: 'var(--globalFont)',
            remark: TEXT_REMARK_OBJECT[5],
            diannao: {
              fontSize: 18,
              fontSizeUnit: 'px',
              letterSpacing: 0,
              letterSpacingUnit: 'px'
            },
            pingban: {
              fontSize: 16,
              fontSizeUnit: 'px',
              letterSpacing: 0,
              letterSpacingUnit: 'px'
            },
            shouji: {
              fontSize: 16,
              fontSizeUnit: 'px',
              letterSpacing: 0,
              letterSpacingUnit: 'px'
            }
          },
          {
            id: 6,
            name: 'content',
            title: '正文',
            fontFamilyType: 1,
            fontFamilyId: 68,
            fontFamily: 'var(--globalFont)',
            remark: '',
            diannao: {
              fontSize: 16,
              fontSizeUnit: 'px',
              letterSpacing: 0,
              letterSpacingUnit: 'px'
            },
            pingban: {
              fontSize: 16,
              fontSizeUnit: 'px',
              letterSpacing: 0,
              letterSpacingUnit: 'px'
            },
            shouji: {
              fontSize: 14,
              fontSizeUnit: 'px',
              letterSpacing: 0,
              letterSpacingUnit: 'px'
            }
          },
          {
            id: 7,
            name: 'self1',
            title: '自定义文本1',
            fontFamilyType: 1,
            fontFamilyId: 68,
            fontFamily: 'var(--globalFont)',
            remark: '',
            diannao: {
              fontSize: 16,
              fontSizeUnit: 'px',
              letterSpacing: 0,
              letterSpacingUnit: 'px'
            },
            pingban: {
              fontSize: 16,
              fontSizeUnit: 'px',
              letterSpacing: 0,
              letterSpacingUnit: 'px'
            },
            shouji: {
              fontSize: 14,
              fontSizeUnit: 'px',
              letterSpacing: 0,
              letterSpacingUnit: 'px'
            }
          },
          {
            id: 8,
            name: 'self2',
            title: '自定义文本2',
            fontFamilyType: 1,
            fontFamilyId: 68,
            fontFamily: 'var(--globalFont)',
            remark: '',
            diannao: {
              fontSize: 16,
              fontSizeUnit: 'px',
              letterSpacing: 0,
              letterSpacingUnit: 'px'
            },
            pingban: {
              fontSize: 16,
              fontSizeUnit: 'px',
              letterSpacing: 0,
              letterSpacingUnit: 'px'
            },
            shouji: {
              fontSize: 14,
              fontSizeUnit: 'px',
              letterSpacing: 0,
              letterSpacingUnit: 'px'
            }
          }
        ],
        fontFaces: [{ id: 68, name: 'Roboto', url: '/themes/ksh/common/font/Roboto.ttf' }],
        anchorTextColor: 'rgb(0, 92, 179)'
      }
    },
    listIndex: -1,
    list: [
      {
        name: '模块库',
        key: 'module',
        icon: 'icon-mokuaiku-',
        list: []
      },
      {
        name: '控件库',
        key: 'widgets',
        icon: 'icon-kongjian-',
        list: []
      },
      {
        name: '模板库',
        key: 'template',
        icon: 'icon-mobanku-',
        list: []
      },
      {
        name: '收藏',
        key: 'collect',
        icon: 'icon-shoucang',
        list: [
          {
            name: '收藏列表',
            list: []
          }
        ]
      },
      {
        name: '公共板块',
        key: 'common',
        icon: 'icon-muban',
        list: [
          {
            name: '公共板块列表',
            list: []
          }
        ]
      },
      {
        name: 'AI建站',
        key: 'aiWebsiteBuilder',
        icon: 'icon-AI',
        list: []
      }
    ],
    hasList: reactive([]),
    history: [],
    bodyKey: 0,
    dialogNodes: [],
    // 行数 列数 是否选中
    rowOption: {
      2: [
        [
          { row: true, col: false, active: true },
          { row: false, col: true }
        ],
        [
          { row: true, col: false, active: true },
          { row: false, col: true }
        ]
      ],
      3: [
        [
          { row: false, col: true, active: true },
          { row: true, col: true },
          { row: true, col: true }
        ],
        [
          { row: true, col: false, active: true },
          { row: false, col: true },
          { row: true, col: true },
          { row: true, col: true }
        ]
      ],
      4: [
        [
          { row: false, col: true },
          { row: true, col: true, active: true }
        ],
        [
          { row: true, col: false, active: true },
          { row: false, col: true },
          { row: true, col: true },
          { row: true, col: true },
          { row: true, col: true }
        ]
      ],
      5: [
        [
          { row: true, col: true },
          { row: true, col: true, active: true }
        ],
        [
          { row: true, col: false, active: true },
          { row: true, col: true },
          { row: true, col: true },
          { row: true, col: true },
          { row: true, col: true }
        ]
      ],
      6: [
        [
          { row: true, col: true, active: true },
          { row: true, col: true }
        ],
        [
          { row: true, col: false, active: true },
          { row: true, col: true },
          { row: true, col: true }
        ]
      ]
    },
    innerKey: 0,
    deviceMode,
    globalFont: 68,
    faqPageNum: null,
    globalBackground: {
      'background-color': {
        diannao: '',
        pingban: '',
        shouji: ''
      },
      'background-image': {
        diannao: '',
        pingban: '',
        shouji: ''
      }
    },
    bannerId: 0,
    banner2Id:0,
    bannerIconId: 0,
    tabId: 0,
    dev4Id: 0,
    imageTextTabId: 0,
    controlIds: {},
    currentLanguage: -1,
    rowWidth: '1400px',
    FData: null,
    commonData: [],
    commonUsedList: [
      { id: 1, name: '首页' },
      { id: 2, name: '详情页' },
      { id: 3, name: '列表页' }
    ],
    commonDialogData: {
      list: [],
      visible: false
    },
    isEditCommon: false,
    editCommonData: {},
    collectData: null,
    functions: new Map(),
    panelAuthList: []
  },
  mutations: {
    UPDATE_CATCHNODE: (state, data) => {
      state.catchNode = data
    },
    UPDATE_isForceEnableArabicContext: (state, data) => {
      state.isForceEnableArabicContext = data
    },
    UPDATE_COMMON_OPERATE_DIALOG: async (state,  { id, visible }) => {
      const {list = []} = await mm.dispatch('getCommonUsedDetail', { id })
      state.commonDialogData = {
        list,
        visible
      }
    },
    CLOSE_COMMON_OPERATE_DIALOG: (state, visible) => {
      state.commonDialogData = {
        list: [],
        visible
      }
    },
    UPDATE_COMMON_DIALOG_VISIBILITY: (state, commonDialog) => {
      state.commonDialog.isVisible = commonDialog.isVisible
    },
    UPDATE_COMMON_DIALOG: (state, commonDialog) => {
      state.commonDialog = commonDialog
    },
    UPDATE_AUTH_INFO: (state, data) => {
      state.authInfo = data
    },
    UPDATE_AUTH_LIST: (state, data) => {
      state.panelAuthList = data
    },
    UPDATE_GLOBAL_THEME: (state, data) => {
      state.authInfo.ksh_global_theme_color = data
    },
    UPDATE_isViewOfHiddenNode: (state, data) => {
      state.isViewOfHiddenNode = data
    },
    UPDATE_COLLECT_DATA: (state, data) => {
      state.collectData = data
    },
    UPDATE_CONTROL_IDS: (state, data) => {
      state.controlIds[data.type] = data.id
    },
    UPDATE_TRANSLATEDIALOG: (state, translateDialog) => {
      state.translateDialog = translateDialog
    },
    UPDATE_BANNER_ID: (state, data) => {
      state.bannerId = data
    },
    UPDATE_BANNER2_ID: (state, data) => {
      state.banner2Id = data
    },
    UPDATE_BANNER_ICON_ID: (state, data) => {
      state.bannerIconId = data
    },
    UPDATE_TAB_ID: (state, data) => {
      state.tabId = data
    },
    UPDATE_IMAGE_TEXT_TAB_ID: (state, data) => {
      state.imageTextTabId = data
    },
    UPDATE_CURRENTLANGUAGE: (state, data) => {
      state.currentLanguage = data
    },
    UPDATE_DEVICEMODE: (state, data) => {
      state.deviceMode = data
    },
    REMOVE_DIALOG_NODES: (state, data) => {
      const index = state.dialogNodes.indexOf(data)
      state.dialogNodes.splice(index, 1)
      // removeControllerData(index)
    },
    UPDATE_INNERKEY: (state, data) => {
      state.innerKey = data
    },
    SHOW_SINGLE_DIALOG: (state, data) => {
      if(isEnableCatching()){
        return
      }

      const res = getClosestBusinessNode(data)
      state.dialogNodes = [res]

      addDragDom(res)
      // const size = measureObjectSize(res)
      // const sizeInKB = size / 1024
      // const sizeInMB = size / (1024 * 1024)
      // console.log(`res 对象内存占用: ${size} 字节 (${sizeInKB.toFixed(2)} KB, ${sizeInMB.toFixed(4)} MB)`)
    },
    SHOW_MUILT_DIALOG: (state, data) => {
      state.dialogNodes[1] = data
    },
    EMPTY_DIALOG: (state, data) => {
      state.dialogNodes = []
    },
    UPDATE_TOP_MENU: (state, data) => {
      state.topMenu = { ...state.topMenu, ...data }
    },
    UPDATE_RIGHT_MENU: (state, data) => {
      state.rightMenu = { ...state.rightMenu, ...data }
    },
    UPDATE_TOOLS: (state, data) => {
      state.tools = data
    },
    UPDATE_LIST_INDEX: (state, data) => {
      state.listIndex = data
    },
    UPDATE_LIST: (state, data) => {
      state.list = data
    },
    UPDATE_BODY: (state) => {
      state.bodyKey++
    },
    UPDATE_HEADER_SAFE: (state, data) => {
      state.headerSafe = data
    },
    SET_GLOBALFONT: (state, data) => {
      state.globalFont = data
    },
    SET_GLOBALBACKGROUND: (state, data) => {
      state.globalBackground = data
    },
    UPDATE_DEV4_ID: (state, data) => {
      state.dev4Id = data
    },
    REGISTER_FUNCTION(state, { name, fn }) {
      state.functions.set(name, fn)
    },
    UNREGISTER_FUNCTION(state, name) {
      state.functions.delete(name)
    },
    // 更新间距信息
    // TODO 可进行标记

    UPDATE_RECT: (state, data) => {},
    UPDATE_HAS_LIST: (state, list) => {
      addIds(list)
      state.hasList = list
      globalThis.hasList = list
    },
    UPDATE_IS_EDIT_COMMON: (state, data) => {
      state.isEditCommon = data
    },
    UPDATE_CURRENT_COMMON: (state, data) => {
      state.editCommonData = data
    },
    // 历史记录
    HISTORY_PUSH: (state) => {
      clearRemainingHistoryQuquesFromCurrent(state)

      state.hasList[0].historyId = Date.now()
      const currentList = mm.utils.deepCopy(toRaw(state.hasList))
      state.history.push(currentList)
      if (state.history.length > 10) {
        state.history.shift()
      }
    },
    // 后退
    HISTORY_PREV: async (state) => {
      updateHistory('backward', state)
    },
    // 前进
    HISTORY_NEXT(state) {
      updateHistory('forward', state)
    }
  },
  actions: {},
  getters: {
    getFunction: (state) => (name) => state.functions.get(name),
    hasFunction: (state) => (name) => state.functions.has(name),
    allFunctions: (state) => Array.from(state.functions.keys())
  }
})
